import { render, staticRenderFns } from "./ArtistAvatar.vue?vue&type=template&id=768a1c9e&scoped=true"
import script from "./ArtistAvatar.vue?vue&type=script&lang=js"
export * from "./ArtistAvatar.vue?vue&type=script&lang=js"
import style0 from "./ArtistAvatar.vue?vue&type=style&index=0&id=768a1c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a1c9e",
  null
  
)

export default component.exports